import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const EditIconFixedFill = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 14.487 14.797' className={className}>
    <path
      id='Label_Right'
      data-name='Label Right'
      d='M15.026,2.376l.527-.542a.585.585,0,0,0,.007-.857L15.392.8a.583.583,0,0,0-.828.037l-.535.527ZM6.6,9.994l1.428-.623,6.46-6.46-1-.989L7.028,8.382,6.369,9.759A.182.182,0,0,0,6.6,9.994Zm-3.04,5.449h8.6c1.311,0,2.08-.762,2.08-2.271V5.021L13.056,6.2v6.914c0,.762-.417,1.15-.923,1.15H3.571a1.022,1.022,0,0,1-1.135-1.15V4.8A1.027,1.027,0,0,1,3.571,3.644H9.906l1.179-1.179H3.556a2.023,2.023,0,0,0-2.3,2.271v8.438A2.02,2.02,0,0,0,3.556,15.443Z'
      transform='translate(-1.256 -0.646)'
      fill='#69767a'
    />
  </SvgIcon>
);

export default EditIconFixedFill;
